<template>
  <div
    style="overflow: unset !important"
    ref="boxRef"
    :class="['order-dialog__item__box']"
  >
    <span
      :class="[
        'order-dialog__item__box__indicator',
        { 'order-dialog__item__box__indicator-opened': showDetails },
      ]"
    >
      <svg width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
        <path
          fill="currentColor"
          d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
        ></path>
      </svg>
    </span>
    <div
      @click="toggleShowDetails"
      class="order-dialog__item__box__header font-weight-bold"
    >
      <slot name="header"></slot>
    </div>
    <div class="order-dialog__item__box__details" v-if="showDetails">
      <slot name="details"></slot>
      <div class="text-right">
        <span
          @click="showDetails = false"
          class="order-dialog__item__box__details__hide-btn cursor-pointer pa-1"
        >
          <vue-icon
            :class="showDetails ? 'triangle-btn' : 'triangle-btn-active'"
            icon="triangleIcon"
            style="transform: rotateY(-180deg)"
          ></vue-icon>
          <span class="d-inline-block ml-1">{{ $t("hide") }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import "../order-dialog/_orderDialog.scss";
export default {
  name: "OrderDialogHeader",
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },
  },
};
</script>

<style scoped></style>
